import * as yup from 'yup';
import { CtaButton } from '@web/molecules';
import { nullableImageFromCMSSchema } from '../schemas';

export const component = CtaButton;

export const schema = yup
  .object({
    href: yup.string().required(),
    variant: yup.string().required(),
    children: yup.string().required(),
    openNewTab: yup.boolean(),
    headerText: yup.string(),
    alignment: yup.string(),
    icon: nullableImageFromCMSSchema,
    iconAlignment: yup.string(),
  })
  .transform(value => ({
    href: value.href?.url || value.href?.cached_url,
    variant: value.button_variant,
    children: value.button_label,
    openNewTab: value.opens_new_tab || false,
    headerText: value.headerText,
    alignment: value.alignment || undefined,
    icon: value.icon || undefined,
    iconAlignment: value.icon_alignment || undefined,
  }));
